import groq from "groq";
import contentBlocks from "./contentBlocks";
import { applyFrench } from "@lib/applyFrenchField";

const collectionBySlug = () => groq`
*[_type == "collectionPage" && slug.current == $handle] | order(_updatedAt desc) {
    "title": ${applyFrench("title", "title_fr")},
    slug,
    "handle": slug.current,
    "description": ${applyFrench("description", "description_fr")},
    explicitRedirect-> {
        from,
        to,
        toLabel
    },
    navigation_description,
    navigation -> {
        linkgroup[] {
            ...,
            "title": ${applyFrench("title", "title_fr")},
            navigationLinks[] {
                'key': _key,
                "title": ${applyFrench("title", "title_fr")},
                'refTitle': link.document->title,
                'type': link.document->_type,
                'link': link.link,
                'handle': link.document->handle,
                'slug': link.document->slug
            },
        }
    },
    collectionSections[]->{
        "handle": slug.current,
    },
    showContentFirst,
    ${contentBlocks},
    openGraphImage,
    seoTitle,
    seoDescription,
    seoTwitterCardStyle,
}[0]`;

export default collectionBySlug;
